import { createSlice } from '@reduxjs/toolkit'
import { GET_USER_AGREEMENT } from '../../config/endpoint';
import { axiosInstance } from '../../config/axiosConfig';
import { set } from 'react-hook-form';

export const getUserIsAggreed = () => (dispatch) => {
    dispatch(setIsLoading(false))
    axiosInstance.get(GET_USER_AGREEMENT)
        .then((res) => {
            dispatch(setUserAgreement(res))
        })
        .catch((err) => {
            dispatch(setUserAgreement({ isAgreed: false, isLoaded: true }))
        }).finally(() => {
            dispatch(setIsLoading(true))
        })
}

const userAgreementSlice = createSlice({
    name: 'userAgreement',
    initialState: {
        isAgreed: false,
        isLoaded: false,
        isConsentSelected: false
    },
    reducers: {
        setUserAgreement: (state, action) => {
            state = {...state, ...action.payload};
            return state;
        },
        setIsLoading: (state, action) => {
            state.isLoaded = action.payload;
            return state;
        },
        setIsConsentSelected: (state, action) => {
            state.isConsentSelected = action.payload;
            return state;
        }
    },
})

export const { setUserAgreement, setIsLoading, setIsConsentSelected } = userAgreementSlice.actions

export default userAgreementSlice.reducer